export default {"src":"/_next/static/media/operated-by.ba735dce.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};